module.exports = __webpack_public_path__ + "media/images/expert__daniel-gygax-ae72481d5567cc19b5fc6b9a449c0a1f.jpg";